/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Account } from '../models/account';
import { AwsAccount } from '../models/aws-account';
import { Response } from '../models/response';
import { AzureAccount } from '../models/azure-account';
import { BitBucketAccount } from '../models/bit-bucket-account';
import { CoderAccount } from '../models/coder-account';
import { GcpAccount } from '../models/gcp-account';
import { VCSOrganizationsRequest } from '../models/vcsorganizations-request';
import { GitHubAccount } from '../models/git-hub-account';
import { GitLabAccount } from '../models/git-lab-account';
import { KubernetesAccount } from '../models/kubernetes-account';
import { OneTimeWebhook } from '../models/one-time-webhook';
import { CloudLinkingRequest } from '../models/cloud-linking-request';
import { VCSLinkingResponse } from '../models/vcslinking-response';
import { VCSLinkingRequest } from '../models/vcslinking-request';
import { VCSTokenDetailsResponse } from '../models/vcstoken-details-response';
import { VCSAccountUpdateRequest } from '../models/vcsaccount-update-request';

/**
 * Ui Accounts Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiAccountsControllerService extends __BaseService {
  static readonly getAllAccountsUsingGETPath = '/cc-ui/v1/accounts/';
  static readonly createAwsAccountUsingPOSTPath = '/cc-ui/v1/accounts/aws/';
  static readonly validateAwsAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/aws/validate';
  static readonly updateAwsAccountUsingPUTPath = '/cc-ui/v1/accounts/aws/{id}';
  static readonly createAzureAccountUsingPOSTPath = '/cc-ui/v1/accounts/azure/';
  static readonly validateAzureAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/azure/validate';
  static readonly updateAzureAccountUsingPUTPath =
    '/cc-ui/v1/accounts/azure/{id}';
  static readonly createBitBucketAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/bitbucket/';
  static readonly validateBitbucketAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/bitbucket/validate';
  static readonly updateBitBucketAccountUsingPUTPath =
    '/cc-ui/v1/accounts/bitbucket/{id}';
  static readonly createCoderAccountUsingPOSTPath = '/cc-ui/v1/accounts/coder/';
  static readonly updateCoderAccountUsingPUTPath =
    '/cc-ui/v1/accounts/coder/{id}';
  static readonly createGcpAccountUsingPOSTPath = '/cc-ui/v1/accounts/gcp/';
  static readonly validateGcpAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/gcp/validate';
  static readonly updateGcpAccountUsingPUTPath = '/cc-ui/v1/accounts/gcp/{id}';
  static readonly getVCSOrganisationsUsingPOSTPath =
    '/cc-ui/v1/accounts/get-organisations';
  static readonly createGitHubAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/github/';
  static readonly validateGithubAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/github/validate';
  static readonly updateGitHubAccountUsingPUTPath =
    '/cc-ui/v1/accounts/github/{id}';
  static readonly createGitLabAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/gitlab/';
  static readonly validateGitlabAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/gitlab/validate';
  static readonly updateGitLabAccountUsingPUTPath =
    '/cc-ui/v1/accounts/gitlab/{id}';
  static readonly createKubernetesAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/kubernetes/';
  static readonly validateKubernetesAccountUsingPOSTPath =
    '/cc-ui/v1/accounts/kubernetes/validate';
  static readonly updateKubernetesAccountUsingPUTPath =
    '/cc-ui/v1/accounts/kubernetes/{id}';
  static readonly requestCloudAccountLinkingUsingPOSTPath =
    '/cc-ui/v1/accounts/link-cloud';
  static readonly requestVCSLinkingUsingPOSTPath =
    '/cc-ui/v1/accounts/link-vcs';
  static readonly getAccountByNameUsingGETPath =
    '/cc-ui/v1/accounts/name/{name}';
  static readonly getVCSTokenDetailsByStackNameUsingGETPath =
    '/cc-ui/v1/accounts/stack/{stackName}/token-details';
  static readonly getAllVCSTokenDetailsUsingGETPath =
    '/cc-ui/v1/accounts/token-details';
  static readonly refreshAllVCSTokenDetailsUsingPOSTPath =
    '/cc-ui/v1/accounts/token-details/refresh';
  static readonly getAccountsByTypeUsingGETPath =
    '/cc-ui/v1/accounts/type/{type}';
  static readonly getVcsOrganizationsByAccountIdUsingGETPath =
    '/cc-ui/v1/accounts/vcs-orgs/{accountId}';
  static readonly updateVCSAccountUsingPATCHPath =
    '/cc-ui/v1/accounts/vcs/{id}';
  static readonly getBitbucketProjectsForWorkspaceUsingGETPath =
    '/cc-ui/v1/accounts/{accountId}/workspaces/{workspace}/projects';
  static readonly getAccountUsingGETPath = '/cc-ui/v1/accounts/{id}';
  static readonly deleteAccountUsingDELETEPath = '/cc-ui/v1/accounts/{id}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllAccounts
   * @return OK
   */
  getAllAccountsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<Account>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/accounts/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Account>>;
      }),
    );
  }
  /**
   * getAllAccounts
   * @return OK
   */
  getAllAccountsUsingGET(): __Observable<Array<Account>> {
    return this.getAllAccountsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<Account>),
    );
  }

  /**
   * createAwsAccount
   * @param awsAccountRequest awsAccountRequest
   * @return OK
   */
  createAwsAccountUsingPOSTResponse(
    awsAccountRequest: AwsAccount,
  ): __Observable<__StrictHttpResponse<AwsAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = awsAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/aws/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AwsAccount>;
      }),
    );
  }
  /**
   * createAwsAccount
   * @param awsAccountRequest awsAccountRequest
   * @return OK
   */
  createAwsAccountUsingPOST(
    awsAccountRequest: AwsAccount,
  ): __Observable<AwsAccount> {
    return this.createAwsAccountUsingPOSTResponse(awsAccountRequest).pipe(
      __map((_r) => _r.body as AwsAccount),
    );
  }

  /**
   * validateAwsAccount
   * @param awsAccount awsAccount
   * @return OK
   */
  validateAwsAccountUsingPOSTResponse(
    awsAccount: AwsAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = awsAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/aws/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateAwsAccount
   * @param awsAccount awsAccount
   * @return OK
   */
  validateAwsAccountUsingPOST(awsAccount: AwsAccount): __Observable<Response> {
    return this.validateAwsAccountUsingPOSTResponse(awsAccount).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateAwsAccount
   * @param params The `UiAccountsControllerService.UpdateAwsAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `awsAccountRequest`: awsAccountRequest
   *
   * @return OK
   */
  updateAwsAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateAwsAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<AwsAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.awsAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/aws/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AwsAccount>;
      }),
    );
  }
  /**
   * updateAwsAccount
   * @param params The `UiAccountsControllerService.UpdateAwsAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `awsAccountRequest`: awsAccountRequest
   *
   * @return OK
   */
  updateAwsAccountUsingPUT(
    params: UiAccountsControllerService.UpdateAwsAccountUsingPUTParams,
  ): __Observable<AwsAccount> {
    return this.updateAwsAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as AwsAccount),
    );
  }

  /**
   * createAzureAccount
   * @param azureAccountRequest azureAccountRequest
   * @return OK
   */
  createAzureAccountUsingPOSTResponse(
    azureAccountRequest: AzureAccount,
  ): __Observable<__StrictHttpResponse<AzureAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = azureAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/azure/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AzureAccount>;
      }),
    );
  }
  /**
   * createAzureAccount
   * @param azureAccountRequest azureAccountRequest
   * @return OK
   */
  createAzureAccountUsingPOST(
    azureAccountRequest: AzureAccount,
  ): __Observable<AzureAccount> {
    return this.createAzureAccountUsingPOSTResponse(azureAccountRequest).pipe(
      __map((_r) => _r.body as AzureAccount),
    );
  }

  /**
   * validateAzureAccount
   * @param azureAccount azureAccount
   * @return OK
   */
  validateAzureAccountUsingPOSTResponse(
    azureAccount: AzureAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = azureAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/azure/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateAzureAccount
   * @param azureAccount azureAccount
   * @return OK
   */
  validateAzureAccountUsingPOST(
    azureAccount: AzureAccount,
  ): __Observable<Response> {
    return this.validateAzureAccountUsingPOSTResponse(azureAccount).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateAzureAccount
   * @param params The `UiAccountsControllerService.UpdateAzureAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `azureAccountRequest`: azureAccountRequest
   *
   * @return OK
   */
  updateAzureAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateAzureAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<AzureAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.azureAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/azure/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AzureAccount>;
      }),
    );
  }
  /**
   * updateAzureAccount
   * @param params The `UiAccountsControllerService.UpdateAzureAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `azureAccountRequest`: azureAccountRequest
   *
   * @return OK
   */
  updateAzureAccountUsingPUT(
    params: UiAccountsControllerService.UpdateAzureAccountUsingPUTParams,
  ): __Observable<AzureAccount> {
    return this.updateAzureAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as AzureAccount),
    );
  }

  /**
   * createBitBucketAccount
   * @param bitbucketAccountRequest bitbucketAccountRequest
   * @return OK
   */
  createBitBucketAccountUsingPOSTResponse(
    bitbucketAccountRequest: BitBucketAccount,
  ): __Observable<__StrictHttpResponse<BitBucketAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = bitbucketAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/bitbucket/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BitBucketAccount>;
      }),
    );
  }
  /**
   * createBitBucketAccount
   * @param bitbucketAccountRequest bitbucketAccountRequest
   * @return OK
   */
  createBitBucketAccountUsingPOST(
    bitbucketAccountRequest: BitBucketAccount,
  ): __Observable<BitBucketAccount> {
    return this.createBitBucketAccountUsingPOSTResponse(
      bitbucketAccountRequest,
    ).pipe(__map((_r) => _r.body as BitBucketAccount));
  }

  /**
   * validateBitbucketAccount
   * @param bitBucketAccount bitBucketAccount
   * @return OK
   */
  validateBitbucketAccountUsingPOSTResponse(
    bitBucketAccount: BitBucketAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = bitBucketAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/bitbucket/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateBitbucketAccount
   * @param bitBucketAccount bitBucketAccount
   * @return OK
   */
  validateBitbucketAccountUsingPOST(
    bitBucketAccount: BitBucketAccount,
  ): __Observable<Response> {
    return this.validateBitbucketAccountUsingPOSTResponse(
      bitBucketAccount,
    ).pipe(__map((_r) => _r.body as Response));
  }

  /**
   * updateBitBucketAccount
   * @param params The `UiAccountsControllerService.UpdateBitBucketAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `bitbucketAccountRequest`: bitbucketAccountRequest
   *
   * @return OK
   */
  updateBitBucketAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateBitBucketAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<BitBucketAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.bitbucketAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/bitbucket/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BitBucketAccount>;
      }),
    );
  }
  /**
   * updateBitBucketAccount
   * @param params The `UiAccountsControllerService.UpdateBitBucketAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `bitbucketAccountRequest`: bitbucketAccountRequest
   *
   * @return OK
   */
  updateBitBucketAccountUsingPUT(
    params: UiAccountsControllerService.UpdateBitBucketAccountUsingPUTParams,
  ): __Observable<BitBucketAccount> {
    return this.updateBitBucketAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as BitBucketAccount),
    );
  }

  /**
   * createCoderAccount
   * @param coderAccountRequest coderAccountRequest
   * @return OK
   */
  createCoderAccountUsingPOSTResponse(
    coderAccountRequest: CoderAccount,
  ): __Observable<__StrictHttpResponse<CoderAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = coderAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/coder/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderAccount>;
      }),
    );
  }
  /**
   * createCoderAccount
   * @param coderAccountRequest coderAccountRequest
   * @return OK
   */
  createCoderAccountUsingPOST(
    coderAccountRequest: CoderAccount,
  ): __Observable<CoderAccount> {
    return this.createCoderAccountUsingPOSTResponse(coderAccountRequest).pipe(
      __map((_r) => _r.body as CoderAccount),
    );
  }

  /**
   * updateCoderAccount
   * @param params The `UiAccountsControllerService.UpdateCoderAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `coderAccount`: coderAccount
   *
   * @return OK
   */
  updateCoderAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateCoderAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<CoderAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.coderAccount;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/coder/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderAccount>;
      }),
    );
  }
  /**
   * updateCoderAccount
   * @param params The `UiAccountsControllerService.UpdateCoderAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `coderAccount`: coderAccount
   *
   * @return OK
   */
  updateCoderAccountUsingPUT(
    params: UiAccountsControllerService.UpdateCoderAccountUsingPUTParams,
  ): __Observable<CoderAccount> {
    return this.updateCoderAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as CoderAccount),
    );
  }

  /**
   * createGcpAccount
   * @param gcpAccountRequest gcpAccountRequest
   * @return OK
   */
  createGcpAccountUsingPOSTResponse(
    gcpAccountRequest: GcpAccount,
  ): __Observable<__StrictHttpResponse<GcpAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = gcpAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/gcp/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GcpAccount>;
      }),
    );
  }
  /**
   * createGcpAccount
   * @param gcpAccountRequest gcpAccountRequest
   * @return OK
   */
  createGcpAccountUsingPOST(
    gcpAccountRequest: GcpAccount,
  ): __Observable<GcpAccount> {
    return this.createGcpAccountUsingPOSTResponse(gcpAccountRequest).pipe(
      __map((_r) => _r.body as GcpAccount),
    );
  }

  /**
   * validateGcpAccount
   * @param gcpAccount gcpAccount
   * @return OK
   */
  validateGcpAccountUsingPOSTResponse(
    gcpAccount: GcpAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = gcpAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/gcp/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateGcpAccount
   * @param gcpAccount gcpAccount
   * @return OK
   */
  validateGcpAccountUsingPOST(gcpAccount: GcpAccount): __Observable<Response> {
    return this.validateGcpAccountUsingPOSTResponse(gcpAccount).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateGcpAccount
   * @param params The `UiAccountsControllerService.UpdateGcpAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `gcpAccountRequest`: gcpAccountRequest
   *
   * @return OK
   */
  updateGcpAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateGcpAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<GcpAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.gcpAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/gcp/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GcpAccount>;
      }),
    );
  }
  /**
   * updateGcpAccount
   * @param params The `UiAccountsControllerService.UpdateGcpAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `gcpAccountRequest`: gcpAccountRequest
   *
   * @return OK
   */
  updateGcpAccountUsingPUT(
    params: UiAccountsControllerService.UpdateGcpAccountUsingPUTParams,
  ): __Observable<GcpAccount> {
    return this.updateGcpAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as GcpAccount),
    );
  }

  /**
   * getVCSOrganisations
   * @param VCSOrganizationsRequest VCSOrganizationsRequest
   * @return OK
   */
  getVCSOrganisationsUsingPOSTResponse(
    VCSOrganizationsRequest: VCSOrganizationsRequest,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = VCSOrganizationsRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/get-organisations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getVCSOrganisations
   * @param VCSOrganizationsRequest VCSOrganizationsRequest
   * @return OK
   */
  getVCSOrganisationsUsingPOST(
    VCSOrganizationsRequest: VCSOrganizationsRequest,
  ): __Observable<Array<string>> {
    return this.getVCSOrganisationsUsingPOSTResponse(
      VCSOrganizationsRequest,
    ).pipe(__map((_r) => _r.body as Array<string>));
  }

  /**
   * createGitHubAccount
   * @param githubAccountRequest githubAccountRequest
   * @return OK
   */
  createGitHubAccountUsingPOSTResponse(
    githubAccountRequest: GitHubAccount,
  ): __Observable<__StrictHttpResponse<GitHubAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = githubAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/github/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GitHubAccount>;
      }),
    );
  }
  /**
   * createGitHubAccount
   * @param githubAccountRequest githubAccountRequest
   * @return OK
   */
  createGitHubAccountUsingPOST(
    githubAccountRequest: GitHubAccount,
  ): __Observable<GitHubAccount> {
    return this.createGitHubAccountUsingPOSTResponse(githubAccountRequest).pipe(
      __map((_r) => _r.body as GitHubAccount),
    );
  }

  /**
   * validateGithubAccount
   * @param gitHubAccount gitHubAccount
   * @return OK
   */
  validateGithubAccountUsingPOSTResponse(
    gitHubAccount: GitHubAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = gitHubAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/github/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateGithubAccount
   * @param gitHubAccount gitHubAccount
   * @return OK
   */
  validateGithubAccountUsingPOST(
    gitHubAccount: GitHubAccount,
  ): __Observable<Response> {
    return this.validateGithubAccountUsingPOSTResponse(gitHubAccount).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateGitHubAccount
   * @param params The `UiAccountsControllerService.UpdateGitHubAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `githubAccountRequest`: githubAccountRequest
   *
   * @return OK
   */
  updateGitHubAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateGitHubAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<GitHubAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.githubAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/github/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GitHubAccount>;
      }),
    );
  }
  /**
   * updateGitHubAccount
   * @param params The `UiAccountsControllerService.UpdateGitHubAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `githubAccountRequest`: githubAccountRequest
   *
   * @return OK
   */
  updateGitHubAccountUsingPUT(
    params: UiAccountsControllerService.UpdateGitHubAccountUsingPUTParams,
  ): __Observable<GitHubAccount> {
    return this.updateGitHubAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as GitHubAccount),
    );
  }

  /**
   * createGitLabAccount
   * @param gitlabAccountRequest gitlabAccountRequest
   * @return OK
   */
  createGitLabAccountUsingPOSTResponse(
    gitlabAccountRequest: GitLabAccount,
  ): __Observable<__StrictHttpResponse<GitLabAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = gitlabAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/gitlab/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GitLabAccount>;
      }),
    );
  }
  /**
   * createGitLabAccount
   * @param gitlabAccountRequest gitlabAccountRequest
   * @return OK
   */
  createGitLabAccountUsingPOST(
    gitlabAccountRequest: GitLabAccount,
  ): __Observable<GitLabAccount> {
    return this.createGitLabAccountUsingPOSTResponse(gitlabAccountRequest).pipe(
      __map((_r) => _r.body as GitLabAccount),
    );
  }

  /**
   * validateGitlabAccount
   * @param gitLabAccount gitLabAccount
   * @return OK
   */
  validateGitlabAccountUsingPOSTResponse(
    gitLabAccount: GitLabAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = gitLabAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/gitlab/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateGitlabAccount
   * @param gitLabAccount gitLabAccount
   * @return OK
   */
  validateGitlabAccountUsingPOST(
    gitLabAccount: GitLabAccount,
  ): __Observable<Response> {
    return this.validateGitlabAccountUsingPOSTResponse(gitLabAccount).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateGitLabAccount
   * @param params The `UiAccountsControllerService.UpdateGitLabAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `gitlabAccountRequest`: gitlabAccountRequest
   *
   * @return OK
   */
  updateGitLabAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateGitLabAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<GitLabAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.gitlabAccountRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/gitlab/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GitLabAccount>;
      }),
    );
  }
  /**
   * updateGitLabAccount
   * @param params The `UiAccountsControllerService.UpdateGitLabAccountUsingPUTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `gitlabAccountRequest`: gitlabAccountRequest
   *
   * @return OK
   */
  updateGitLabAccountUsingPUT(
    params: UiAccountsControllerService.UpdateGitLabAccountUsingPUTParams,
  ): __Observable<GitLabAccount> {
    return this.updateGitLabAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as GitLabAccount),
    );
  }

  /**
   * createKubernetesAccount
   * @param k8sAccountRequest k8sAccountRequest
   * @return OK
   */
  createKubernetesAccountUsingPOSTResponse(
    k8sAccountRequest: KubernetesAccount,
  ): __Observable<__StrictHttpResponse<KubernetesAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = k8sAccountRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/kubernetes/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesAccount>;
      }),
    );
  }
  /**
   * createKubernetesAccount
   * @param k8sAccountRequest k8sAccountRequest
   * @return OK
   */
  createKubernetesAccountUsingPOST(
    k8sAccountRequest: KubernetesAccount,
  ): __Observable<KubernetesAccount> {
    return this.createKubernetesAccountUsingPOSTResponse(
      k8sAccountRequest,
    ).pipe(__map((_r) => _r.body as KubernetesAccount));
  }

  /**
   * validateKubernetesAccount
   * @param kubernetesAccount kubernetesAccount
   * @return OK
   */
  validateKubernetesAccountUsingPOSTResponse(
    kubernetesAccount: KubernetesAccount,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = kubernetesAccount;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/kubernetes/validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * validateKubernetesAccount
   * @param kubernetesAccount kubernetesAccount
   * @return OK
   */
  validateKubernetesAccountUsingPOST(
    kubernetesAccount: KubernetesAccount,
  ): __Observable<Response> {
    return this.validateKubernetesAccountUsingPOSTResponse(
      kubernetesAccount,
    ).pipe(__map((_r) => _r.body as Response));
  }

  /**
   * updateKubernetesAccount
   * @param params The `UiAccountsControllerService.UpdateKubernetesAccountUsingPUTParams` containing the following parameters:
   *
   * - `k8sAccountRequest`: k8sAccountRequest
   *
   * - `id`: id
   *
   * @return OK
   */
  updateKubernetesAccountUsingPUTResponse(
    params: UiAccountsControllerService.UpdateKubernetesAccountUsingPUTParams,
  ): __Observable<__StrictHttpResponse<KubernetesAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.k8sAccountRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/accounts/kubernetes/${encodeURIComponent(
          String(params.id),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesAccount>;
      }),
    );
  }
  /**
   * updateKubernetesAccount
   * @param params The `UiAccountsControllerService.UpdateKubernetesAccountUsingPUTParams` containing the following parameters:
   *
   * - `k8sAccountRequest`: k8sAccountRequest
   *
   * - `id`: id
   *
   * @return OK
   */
  updateKubernetesAccountUsingPUT(
    params: UiAccountsControllerService.UpdateKubernetesAccountUsingPUTParams,
  ): __Observable<KubernetesAccount> {
    return this.updateKubernetesAccountUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as KubernetesAccount),
    );
  }

  /**
   * requestCloudAccountLinking
   * @param cloudLinkingRequest cloudLinkingRequest
   * @return OK
   */
  requestCloudAccountLinkingUsingPOSTResponse(
    cloudLinkingRequest: CloudLinkingRequest,
  ): __Observable<__StrictHttpResponse<OneTimeWebhook>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = cloudLinkingRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/link-cloud`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OneTimeWebhook>;
      }),
    );
  }
  /**
   * requestCloudAccountLinking
   * @param cloudLinkingRequest cloudLinkingRequest
   * @return OK
   */
  requestCloudAccountLinkingUsingPOST(
    cloudLinkingRequest: CloudLinkingRequest,
  ): __Observable<OneTimeWebhook> {
    return this.requestCloudAccountLinkingUsingPOSTResponse(
      cloudLinkingRequest,
    ).pipe(__map((_r) => _r.body as OneTimeWebhook));
  }

  /**
   * requestVCSLinking
   * @param vcsLinkingRequest vcsLinkingRequest
   * @return OK
   */
  requestVCSLinkingUsingPOSTResponse(
    vcsLinkingRequest: VCSLinkingRequest,
  ): __Observable<__StrictHttpResponse<VCSLinkingResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = vcsLinkingRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/link-vcs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VCSLinkingResponse>;
      }),
    );
  }
  /**
   * requestVCSLinking
   * @param vcsLinkingRequest vcsLinkingRequest
   * @return OK
   */
  requestVCSLinkingUsingPOST(
    vcsLinkingRequest: VCSLinkingRequest,
  ): __Observable<VCSLinkingResponse> {
    return this.requestVCSLinkingUsingPOSTResponse(vcsLinkingRequest).pipe(
      __map((_r) => _r.body as VCSLinkingResponse),
    );
  }

  /**
   * getAccountByName
   * @param name name
   * @return OK
   */
  getAccountByNameUsingGETResponse(
    name: string,
  ): __Observable<__StrictHttpResponse<Account>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/accounts/name/${encodeURIComponent(String(name))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Account>;
      }),
    );
  }
  /**
   * getAccountByName
   * @param name name
   * @return OK
   */
  getAccountByNameUsingGET(name: string): __Observable<Account> {
    return this.getAccountByNameUsingGETResponse(name).pipe(
      __map((_r) => _r.body as Account),
    );
  }

  /**
   * getVCSTokenDetailsByStackName
   * @param stackName stackName
   * @return OK
   */
  getVCSTokenDetailsByStackNameUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<VCSTokenDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/accounts/stack/${encodeURIComponent(
          String(stackName),
        )}/token-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VCSTokenDetailsResponse>;
      }),
    );
  }
  /**
   * getVCSTokenDetailsByStackName
   * @param stackName stackName
   * @return OK
   */
  getVCSTokenDetailsByStackNameUsingGET(
    stackName: string,
  ): __Observable<VCSTokenDetailsResponse> {
    return this.getVCSTokenDetailsByStackNameUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as VCSTokenDetailsResponse),
    );
  }

  /**
   * getAllVCSTokenDetails
   * @return OK
   */
  getAllVCSTokenDetailsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<VCSTokenDetailsResponse>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/accounts/token-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<VCSTokenDetailsResponse>>;
      }),
    );
  }
  /**
   * getAllVCSTokenDetails
   * @return OK
   */
  getAllVCSTokenDetailsUsingGET(): __Observable<
    Array<VCSTokenDetailsResponse>
  > {
    return this.getAllVCSTokenDetailsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<VCSTokenDetailsResponse>),
    );
  }

  /**
   * refreshAllVCSTokenDetails
   */
  refreshAllVCSTokenDetailsUsingPOSTResponse(): __Observable<
    __StrictHttpResponse<null>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/accounts/token-details/refresh`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * refreshAllVCSTokenDetails
   */
  refreshAllVCSTokenDetailsUsingPOST(): __Observable<null> {
    return this.refreshAllVCSTokenDetailsUsingPOSTResponse().pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getAccountsByType
   * @param type type
   * @return OK
   */
  getAccountsByTypeUsingGETResponse(
    type: 'VERSION_CONTROL' | 'CLOUD' | 'CODER',
  ): __Observable<__StrictHttpResponse<Array<Account>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/accounts/type/${encodeURIComponent(String(type))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Account>>;
      }),
    );
  }
  /**
   * getAccountsByType
   * @param type type
   * @return OK
   */
  getAccountsByTypeUsingGET(
    type: 'VERSION_CONTROL' | 'CLOUD' | 'CODER',
  ): __Observable<Array<Account>> {
    return this.getAccountsByTypeUsingGETResponse(type).pipe(
      __map((_r) => _r.body as Array<Account>),
    );
  }

  /**
   * getVcsOrganizationsByAccountId
   * @param accountId accountId
   * @return OK
   */
  getVcsOrganizationsByAccountIdUsingGETResponse(
    accountId: string,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (accountId != null)
      __params = __params.set('accountId', accountId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/accounts/vcs-orgs/${encodeURIComponent(String(accountId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getVcsOrganizationsByAccountId
   * @param accountId accountId
   * @return OK
   */
  getVcsOrganizationsByAccountIdUsingGET(
    accountId: string,
  ): __Observable<Array<string>> {
    return this.getVcsOrganizationsByAccountIdUsingGETResponse(accountId).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * updateVCSAccount
   * @param params The `UiAccountsControllerService.UpdateVCSAccountUsingPATCHParams` containing the following parameters:
   *
   * - `vcsAccountUpdateRequest`: vcsAccountUpdateRequest
   *
   * - `id`: id
   */
  updateVCSAccountUsingPATCHResponse(
    params: UiAccountsControllerService.UpdateVCSAccountUsingPATCHParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.vcsAccountUpdateRequest;

    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl +
        `/cc-ui/v1/accounts/vcs/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * updateVCSAccount
   * @param params The `UiAccountsControllerService.UpdateVCSAccountUsingPATCHParams` containing the following parameters:
   *
   * - `vcsAccountUpdateRequest`: vcsAccountUpdateRequest
   *
   * - `id`: id
   */
  updateVCSAccountUsingPATCH(
    params: UiAccountsControllerService.UpdateVCSAccountUsingPATCHParams,
  ): __Observable<null> {
    return this.updateVCSAccountUsingPATCHResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getBitbucketProjectsForWorkspace
   * @param params The `UiAccountsControllerService.GetBitbucketProjectsForWorkspaceUsingGETParams` containing the following parameters:
   *
   * - `workspace`: workspace
   *
   * - `accountId`: accountId
   *
   * @return OK
   */
  getBitbucketProjectsForWorkspaceUsingGETResponse(
    params: UiAccountsControllerService.GetBitbucketProjectsForWorkspaceUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/accounts/${encodeURIComponent(
          String(params.accountId),
        )}/workspaces/${encodeURIComponent(String(params.workspace))}/projects`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getBitbucketProjectsForWorkspace
   * @param params The `UiAccountsControllerService.GetBitbucketProjectsForWorkspaceUsingGETParams` containing the following parameters:
   *
   * - `workspace`: workspace
   *
   * - `accountId`: accountId
   *
   * @return OK
   */
  getBitbucketProjectsForWorkspaceUsingGET(
    params: UiAccountsControllerService.GetBitbucketProjectsForWorkspaceUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getBitbucketProjectsForWorkspaceUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getAccount
   * @param id id
   * @return OK
   */
  getAccountUsingGETResponse(
    id: string,
  ): __Observable<__StrictHttpResponse<Account>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/accounts/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Account>;
      }),
    );
  }
  /**
   * getAccount
   * @param id id
   * @return OK
   */
  getAccountUsingGET(id: string): __Observable<Account> {
    return this.getAccountUsingGETResponse(id).pipe(
      __map((_r) => _r.body as Account),
    );
  }

  /**
   * deleteAccount
   * @param id id
   * @return OK
   */
  deleteAccountUsingDELETEResponse(
    id: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/accounts/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteAccount
   * @param id id
   * @return OK
   */
  deleteAccountUsingDELETE(id: string): __Observable<boolean> {
    return this.deleteAccountUsingDELETEResponse(id).pipe(
      __map((_r) => _r.body as boolean),
    );
  }
}

module UiAccountsControllerService {
  /**
   * Parameters for updateAwsAccountUsingPUT
   */
  export interface UpdateAwsAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * awsAccountRequest
     */
    awsAccountRequest: AwsAccount;
  }

  /**
   * Parameters for updateAzureAccountUsingPUT
   */
  export interface UpdateAzureAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * azureAccountRequest
     */
    azureAccountRequest: AzureAccount;
  }

  /**
   * Parameters for updateBitBucketAccountUsingPUT
   */
  export interface UpdateBitBucketAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * bitbucketAccountRequest
     */
    bitbucketAccountRequest: BitBucketAccount;
  }

  /**
   * Parameters for updateCoderAccountUsingPUT
   */
  export interface UpdateCoderAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * coderAccount
     */
    coderAccount: CoderAccount;
  }

  /**
   * Parameters for updateGcpAccountUsingPUT
   */
  export interface UpdateGcpAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * gcpAccountRequest
     */
    gcpAccountRequest: GcpAccount;
  }

  /**
   * Parameters for updateGitHubAccountUsingPUT
   */
  export interface UpdateGitHubAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * githubAccountRequest
     */
    githubAccountRequest: GitHubAccount;
  }

  /**
   * Parameters for updateGitLabAccountUsingPUT
   */
  export interface UpdateGitLabAccountUsingPUTParams {
    /**
     * id
     */
    id: string;

    /**
     * gitlabAccountRequest
     */
    gitlabAccountRequest: GitLabAccount;
  }

  /**
   * Parameters for updateKubernetesAccountUsingPUT
   */
  export interface UpdateKubernetesAccountUsingPUTParams {
    /**
     * k8sAccountRequest
     */
    k8sAccountRequest: KubernetesAccount;

    /**
     * id
     */
    id: string;
  }

  /**
   * Parameters for updateVCSAccountUsingPATCH
   */
  export interface UpdateVCSAccountUsingPATCHParams {
    /**
     * vcsAccountUpdateRequest
     */
    vcsAccountUpdateRequest: VCSAccountUpdateRequest;

    /**
     * id
     */
    id: string;
  }

  /**
   * Parameters for getBitbucketProjectsForWorkspaceUsingGET
   */
  export interface GetBitbucketProjectsForWorkspaceUsingGETParams {
    /**
     * workspace
     */
    workspace: string;

    /**
     * accountId
     */
    accountId: string;
  }
}

export { UiAccountsControllerService };
